import { isPlainObject } from '../util/util';

const FILTERED = '[Filtered]';

const TOKEN_PREFIX = 'eyJ';
const JOSE = /\beyJ[\w-]+(?:(?:\.|%2[Ee])[\w-]*){1,4}/g;

// URLSearchParams does the decoding, but it throws the encoded form away, and the redaction has to
// hit the text as it is actually written — so the raw values are sliced out by hand.
const rawQueryValues = (text: string): string[] => {
  const query = text.split('#')[0].split('?')[1];
  if (!query) return [];

  return query
    .split(/[&\s]/)
    .filter((pair) => pair.includes('='))
    .map((pair) => pair.slice(pair.indexOf('=') + 1));
};

const holdsToken = (rawValue: string): boolean =>
  new URLSearchParams(`value=${rawValue}`).get('value')?.startsWith(TOKEN_PREFIX) ?? false;

const redactUrlParams = (text: string): string =>
  rawQueryValues(text)
    .filter(holdsToken)
    .reduce((redacted, rawValue) => redacted.split(rawValue).join(FILTERED), text);

export const redactToken = (value: string): string =>
  redactUrlParams(value).replace(JOSE, FILTERED);

export const redactTokensDeep = <T>(value: T): T => {
  if (typeof value === 'string') {
    return redactToken(value) as T;
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) => (value[index] = redactTokensDeep(item)));
  } else if (isPlainObject(value)) {
    const record: Record<string, unknown> = value;
    Object.keys(record).forEach((key) => (record[key] = redactTokensDeep(record[key])));
  }

  return value;
};
